module.exports = __webpack_public_path__ + "static/csumb-logo-blue-d1aff61d55748ac974a232304ee2bff8.svg";